module.exports = __webpack_public_path__ + "static/media/HackByTheBeach.33fb45d7.jpeg";